import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import SessionExpired from "../views/SessionExpired.vue";
import HomeView from "../views/HomeView.vue";
import GlobalErrorView from "../views/GlobalErrorView.vue";
import ActiveCallView from "../views/ActiveCallView.vue";
import LoginPage from "../pages/LoginPage.vue";

export const routes: RouteRecordRaw[] = [
  {
    path: "/login",
    name: "Login",
    component: LoginPage,
    meta: { requiresAuth: false },
  },
  {
    path: "/:catchAll(.*)/expired",
    name: "SessionExpired",
    component: SessionExpired,
  },
  {
    path: "/:catchAll(.*)/error",
    name: "Error",
    component: GlobalErrorView,
  },
  {
    path: "/:base/call/:sessionId",
    name: "ActiveCall",
    component: ActiveCallView,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "Home",
    component: HomeView,
    meta: { requiresAuth: true },
  },
];

const router =
  // @ts-ignore
  window.VueRouter?.createRouter({
    // @ts-ignore
    history: window.VueRouter.createWebHistory(),
    routes,
  }) ??
  createRouter({
    history: createWebHistory(),
    routes,
  });

// Navigation guard for authentication
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('vc_jwt_token')
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth !== false)

  if (requiresAuth && !token) {
    next({ name: 'Login' })
  } else if (to.name === 'Login' && token) {
    next({ name: 'Home' })
  } else {
    next()
  }
})

export default router;
